export const CONTENT_DETAIL_MODAL_TRACK_ID = {
  closeButton: 'closeButton',
  creatorName: 'creatorName',
  downloadButton: 'downloadButton',
  modal: 'modal',
  nextButton: 'nextButton',
  onOpen: 'onOpen',
  preview: 'preview',
  previousButton: 'previousButton',
  shareButton: 'shareButton',
  viewButton: 'viewButton',
} as const;

export const CONTENT_DETAIL_MODAL_DEFAULT_TRACK_ID = {
  [CONTENT_DETAIL_MODAL_TRACK_ID.closeButton]: 'foam-content-modal-close',
  [CONTENT_DETAIL_MODAL_TRACK_ID.creatorName]: 'foam-content-modal-creatorName',
  [CONTENT_DETAIL_MODAL_TRACK_ID.downloadButton]: 'foam-content-modal-download',
  [CONTENT_DETAIL_MODAL_TRACK_ID.modal]: 'foam-content-modal',
  [CONTENT_DETAIL_MODAL_TRACK_ID.nextButton]: 'foam-content-modal-next',
  [CONTENT_DETAIL_MODAL_TRACK_ID.onOpen]: 'foam-content-modal',
  [CONTENT_DETAIL_MODAL_TRACK_ID.preview]: 'foam-content-modal-preview',
  [CONTENT_DETAIL_MODAL_TRACK_ID.previousButton]: 'foam-content-modal-previous',
  [CONTENT_DETAIL_MODAL_TRACK_ID.shareButton]: 'foam-content-modal-share',
  [CONTENT_DETAIL_MODAL_TRACK_ID.viewButton]: 'foam-content-modal-view',
} as const;
